import { useEffect } from 'react';

import { DocumentType } from '@lglp/prismic-client';
import { useDispatch, useSelector } from 'react-redux';

import { getDocumentsByIds } from '../actions/prismic';
import { RootState } from '../reducers';
import { getDocsByIds } from '../selectors/entities';
import { getDocsByIdsError } from '../selectors/errors';
import { getDocsLoaded } from '../selectors/loaded';
import { getDocsByIdsLoader, getLoadingIds } from '../selectors/loaders';

const useDocumentsByIds = <T>(
  documentIds: {
    id: string;
    type: DocumentType;
  }[]
): { data: T; error: any; loading: any } => {
  const dispatch = useDispatch();
  const ids = documentIds.map((documentId) => documentId.id);

  const data: T = useSelector((state) => getDocsByIds(state, documentIds));
  const error = useSelector((state) => getDocsByIdsError(ids, state));
  const loading = useSelector((state) => getDocsByIdsLoader(ids, state));
  const loadingIdsRaw: Record<string, Boolean> = useSelector((state) =>
    getLoadingIds(state)
  );

  const loadingIds = Object.keys(loadingIdsRaw || {}).reduce(
    (acc, key) => [...acc, ...key.split(',')],
    []
  );
  const loadedIds: Record<string, Boolean> =
    useSelector((state) => getDocsLoaded(state as RootState)) || {};

  const idsToFetch: string[] = [];
  ids.forEach((id) => {
    if (!loadedIds[id] && !loadingIds.some((loadingId) => loadingId === id)) {
      idsToFetch.push(id);
    }
  });

  useEffect(() => {
    if (!loading && !error && idsToFetch.length > 0) {
      dispatch(getDocumentsByIds(idsToFetch));
    }
  }, [dispatch, data, loading, error, idsToFetch]);

  return { data, error, loading };
};

export default useDocumentsByIds;
